import React from "react";
import { Box, Typography } from "@mui/material";

const PaginationInfoView = ({ paginationInfo, currentPage }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" color="textSecondary">
        {paginationInfo.totalCount} total applications • Page {currentPage + 1}{" "}
        of {paginationInfo.totalPages}
      </Typography>
    </Box>
  );
};

export default PaginationInfoView;
